import Form from "../modules/form";

export default {
  init() {
    $("form.cform").each(function () {
      new Form($(this)[0]);
    });
  },
};
